module.exports = __webpack_public_path__ + "media/ignite-ft-zedd-worlds-2016-league-of-legends.5469f458.mp3";